var map = {
	"./bolt.svg": "f8cc",
	"./box.svg": "6686",
	"./buy-data.svg": "82f5",
	"./device.svg": "fdd8",
	"./electricity.svg": "deae",
	"./flight.svg": "739b",
	"./mobile-phone.svg": "d2d9",
	"./payment-card-green.svg": "c036",
	"./payment-card.svg": "1d48",
	"./reward-pack.svg": "c444",
	"./shop.svg": "1161",
	"./transfer.svg": "4804",
	"./tv.svg": "0eee",
	"./users.svg": "91df",
	"./wallet.svg": "838f",
	"./withdraw-funds.svg": "64e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a720";